import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './modules/App/components/AppContainer';
import * as serviceWorker from './serviceWorker';
import store from "./store/store";
import Provider from "react-redux/es/components/Provider";

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
